module.exports = __webpack_public_path__ + "img/ch53.b43b0e45.jpg";